import styled from "styled-components";
import { ReportsGrid } from "../reports/reports.styles";
import { AddSectorButton } from "../sectors/sectors.styles";
export const StaffGrid = styled(ReportsGrid)`
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  column-gap: 1.5rem;
`;
export const AddMemberButton = styled(AddSectorButton)`
  min-width: 150px;
  max-width: 250px;
`;

export const SearchContainer = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20%;
  margin-bottom: 1rem;
  @media (max-width: 1200px) {
    gap: 2rem;
  }
  @media (max-width: 1000px) {
    flex-direction: column-reverse;
  }
`;
